var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconColor = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("g", null,
                    React.createElement("path", { d: "M6.2,1.7h14c2.2,0,4,1.8,4,4v1c0,2.2-1.8,4-4,4h-14c-2.2,0-4-1.8-4-4v-1C2.2,3.5,4,1.7,6.2,1.7z" }),
                    React.createElement("path", { d: "M6.2,2.4h14c1.8,0,3.2,1.5,3.2,3.2v1c0,1.8-1.5,3.2-3.2,3.2h-14c-1.8,0-3.2-1.5-3.2-3.2v-1\n                            C2.9,3.9,4.4,2.4,6.2,2.4z" })),
                React.createElement("path", { d: "M25.6,6.2h2.2v7.9H15.1v4.7" }),
                React.createElement("g", { transform: "translate(11 17.128)" },
                    React.createElement("path", { d: "M3,1.7h2.4c0.4,0,0.8,0.4,0.8,0.8v6.7c0,1.1-0.9,2-2,2l0,0c-1.1,0-2-0.9-2-2V2.5C2.2,2,2.5,1.7,3,1.7z" }),
                    React.createElement("path", { d: "M3.2,2.2h2c0.3,0,0.5,0.2,0.5,0.5v6.5c0,0.8-0.7,1.5-1.5,1.5c0,0,0,0,0,0l0,0c-0.8,0-1.5-0.7-1.5-1.5l0,0V2.7\n                            C2.7,2.4,2.9,2.2,3.2,2.2z" }))))));
});
export default IconColor;
//# sourceMappingURL=IconColor.js.map